import { CalendarCheck } from "lucide-react";
import { whatsappLink } from "../data/site";

export const MobileCtaBar = () => (
  <div
    data-testid="mobile-cta-bar"
    className="fixed bottom-0 inset-x-0 z-50 lg:hidden glass-card border-t border-sky-500/25 px-4 py-3 flex items-center gap-3"
  >
    <a
      data-testid="mobile-cta-demo-btn"
      href="/#contact"
      className="flex-1 inline-flex items-center justify-center gap-2 rounded-lg bg-orange-500 hover:bg-orange-600 text-white font-display font-bold text-sm px-4 py-3 transition-colors duration-200 shadow-[0_0_20px_rgba(249,115,22,0.35)]"
    >
      <CalendarCheck className="w-4 h-4" />
      Book Free Demo
    </a>
    <a
      data-testid="mobile-cta-whatsapp-btn"
      href={whatsappLink()}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      className="inline-flex items-center justify-center gap-2 rounded-lg bg-[#25D366] hover:bg-[#1fb857] text-[#060913] font-display font-bold text-sm px-5 py-3 transition-colors duration-200"
    >
      <svg viewBox="0 0 32 32" className="w-5 h-5 fill-current" aria-hidden="true">
        <path d="M16 2.7C8.7 2.7 2.8 8.6 2.8 15.9c0 2.6.8 5 2.1 7L2.7 29.3l6.6-2.1c1.9 1.2 4.2 1.8 6.6 1.8 7.3 0 13.2-5.9 13.2-13.1S23.3 2.7 16 2.7zm6.6 15.8c-.4-.2-2.1-1.1-2.5-1.2-.3-.1-.6-.2-.8.2-.2.4-.9 1.2-1.1 1.4-.2.2-.4.3-.8.1-.4-.2-1.5-.6-2.9-1.9-1.1-1-1.8-2.2-2-2.6-.2-.4 0-.6.2-.8l.6-.7c.2-.2.3-.4.4-.6.1-.2 0-.5 0-.6-.1-.2-.8-2.1-1.1-2.9-.3-.8-.6-.7-.8-.7h-.7c-.2 0-.6.1-1 .5-.3.4-1.2 1.2-1.2 3s1.3 3.5 1.5 3.7c.2.2 2.5 3.9 6.1 5.4.9.4 1.5.6 2.1.8.9.3 1.7.2 2.3.1.7-.1 2.1-.9 2.4-1.7.3-.9.3-1.6.2-1.7-.1-.2-.4-.3-.8-.5z" />
      </svg>
      WhatsApp
    </a>
  </div>
);
